module.exports = __webpack_public_path__ + "static/media/photo132.8edd6ffa.jpg";